import React from 'react';
import {Tab, Tabs, TabList, TabPanel} from 'react-tabs';
import style from './styles/_business-content.scss';
import {PropTypes} from 'prop-types';
import BusinessContentItem from './BusinessContentItem.jsx';

class BusinessContentContainer extends React.Component {
  render() {
    return (
      <section className="business-contents">
        {
          this.props.contents.map(contentItem =>
            <BusinessContentItem
              title={contentItem.title}
              content={contentItem.content}
            />
          )
        }
      </section>
    );
  }
}

BusinessContentContainer.propTypes = {
  contents: PropTypes.array
}

export default BusinessContentContainer;



// WEBPACK FOOTER //
// ./components/business/business-page/BusinessContentContainer.jsx